angular.module('psModule').controller('SigningPageCtrl',
    function($scope, $translate, $window){

    $scope.individualId = individualId();
    $scope.lang = () => $translate.use();
    $scope.redirectBaseUri = redirectBaseUri();

    function individualId() {
        return $scope.$root.config && $scope.$root.config.individualId || null;
    }

    function redirectBaseUri() {
        if ($scope.$root.config && $scope.$root.config.redirect_base_uri) {
            return $scope.$root.config.redirect_base_uri;
        }
        return $window.location.origin + '/ps/#/signing';
    }

 });
